import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useLicenseEntitlementLimit } from '#layers/access/composables/use-license-entitlement-limit';
import { CREATE_MODE_ITEM_ID } from '#layers/data-model/public';

/**
 * Route-level backstop for the role-create page. The create action already guards, but the detail
 * route is directly reachable by URL, so a hard-blocked user could bypass it. Only guards the
 * create route (not editing an existing role) and redirects to the roles listing when custom roles
 * are hard-blocked. Soft limits stay reachable; non-admins fail open.
 */
export default defineNuxtRouteMiddleware(async (to) => {
	if (to.params.id !== CREATE_MODE_ITEM_ID) return;

	const { isCreationBlocked } = useLicenseEntitlementLimit();

	if (await isCreationBlocked('custom_roles')) {
		return { name: 'workspace.settings.access.roles.listing', params: { workspace: to.params.workspace } };
	}
});
